import React, { useEffect, useState } from 'react';
import { Hourglass, Flame } from 'lucide-react';
export function CountdownBar() {
  const [timeLeft, setTimeLeft] = useState(900); // 15 minutes in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) return 900; // Reset to 15 minutes when it hits 0
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formatTime = (num: number) => num.toString().padStart(2, '0');
  return <div className="fixed top-0 left-0 w-full bg-[#1F3A5F] text-white py-2 z-[100] shadow-md flex justify-center items-center text-sm md:text-base font-semibold tracking-wide" data-id="element-59">
      <div className="flex items-center gap-2 md:gap-4 px-4" data-id="element-60">
        <div className="flex items-center gap-2" data-id="element-61">
          <Hourglass size={16} className="text-[#D4A574]" data-id="element-62" />
          <span data-id="element-63">
            OFERTA EXPIRA EN: {formatTime(minutes)}:{formatTime(seconds)}
          </span>
        </div>
        <span className="text-gray-400" data-id="element-64">|</span>
        <div className="flex items-center gap-2 text-[#D4A574]" data-id="element-65">
          <Flame size={16} data-id="element-66" />
          <span data-id="element-67">CUPOS LIMITADOS</span>
        </div>
      </div>
    </div>;
}